import React from 'react';
import './css/partners.css';

const Partners = () => {
  // Array of logo files from the public/logo folder
  const logos = [
    '/logo/FNS-LogoEN-Text-B.svg',
    '/logo/header-logo-2.svg',
    '/logo/Logo1.svg',
    '/logo/Logo2.svg',
    '/logo/logo-white.svg',
    '/logo/logo.svg',
    '/logo/Ministry_of_Investment_Logo-white.svg',
    '/logo/ministry.svg',
    '/logo/ZATCA-logo.svg'
  ];

  return (
    <section className='partners'>
        <div className='container'>
            <div className='logos-scroll-container'>
                <div className='logos-scroll'>
                    {/* First set of logos */}
                    {logos.map((logo, index) => (
                        <div key={`first-${index}`} className='logo-item'>
                            <img src={logo} alt={`Partner logo ${index + 1}`} />
                        </div>
                    ))}
                    {/* Second set for seamless scrolling */}
                    {logos.map((logo, index) => (
                        <div key={`second-${index}`} className='logo-item'>
                            <img src={logo} alt={`Partner logo ${index + 1}`} />
                        </div>
                    ))}
                    {/* Third set for better loop effect */}
                    {logos.map((logo, index) => (
                        <div key={`third-${index}`} className='logo-item'>
                            <img src={logo} alt={`Partner logo ${index + 1}`} />
                        </div>
                    ))}
                </div>
            </div>
        </div>
    </section>
  )
}

export default Partners
